import { Component } from 'react';
import { connect } from 'react-redux';

import Home from '../home/';
import { Helmet } from 'react-helmet';
import { set } from 'actions/configuration';

class NissanHome extends Component {
  constructor(props) {
    super(props);

    this.props.set({
      brand: 'nissan',
      style: 'red',
      brand_id: 4,
      legacy_service_option: false,
    });
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>Yacopini Nissan - Turnos de taller</title>
          <meta name="description" content="Turnos de taller/postventa para tu vehículo Nissan." />
          <link rel="icon" href="favicon-nissan.ico" type="image/png" />
        </Helmet>
        <Home />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    set: config => {
      dispatch(set(config));
    },
  };
};

export default connect(null, mapDispatchToProps)(NissanHome);
